export const MEDIA = {
  logo: "/gamya-icon.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/a19dcbc6-d498-4f9d-b3b8-b11262d87f33/images/8ab9f533a1be843c894f6aff75d25763daffc1fc738b8a4294382379af90c8b1.png",
  ev: "https://static.prod-images.emergentagent.com/jobs/a19dcbc6-d498-4f9d-b3b8-b11262d87f33/images/0a34322611bab6afef3a8e7a352c4e98e325ca351dc1349d95af937390f36280.png",
  solar:
    "https://images.unsplash.com/photo-1634412115840-42bd1e095288?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzb2xhciUyMHBhbmVscyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzY5NjA2Njl8MA&ixlib=rb-4.1.0&q=85",
  ppa:
    "https://images.unsplash.com/photo-1758518730384-be3d205838e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBlb3BsZSUyMGhhbmRzaGFrZSUyMG1lZXRpbmd8ZW58MHx8fHwxNzc2OTYwNjcwfDA&ixlib=rb-4.1.0&q=85",
  hybrid:
    "https://images.unsplash.com/photo-1497440001374-f26997328c1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  it:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  about:
    "https://images.pexels.com/photos/31960307/pexels-photo-31960307.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const BRAND = {
  name: "Gamya Consultancy & Electric Solutions",
  legal_name: "Gamya Consultancy & Electric Solutions Pvt Ltd",
  short_name: "Gamya",
  tagline: "Powering Tomorrow, Sustainably.",
  email: "info@gamyaconsultancyandelectricsolutions.com",
  phone: "+91 90 656565 30",
  phone_tel: "+919065656530",
  address: "Address coming soon",
};
